import React, { useState } from 'react';
import '../css/Auth.css';
import { Link } from 'react-router-dom';

function Register() {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleRegister = () => {};

  return (
    <div className="auth-form-container">
      <p className="auth-form-title">Register</p>
      <form className="auth-form" onSubmit={handleRegister}>
        <label className="auth-form-input-label">
          Username
          <input
            className="auth-form-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          ></input>
        </label>
        <label className="auth-form-input-label">
          Email
          <input
            className="auth-form-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></input>
        </label>
        <label className="auth-form-input-label">
          Password
          <input
            className="auth-form-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type={'password'}
          ></input>
        </label>
        <button className="auth-form-submit-button">Register</button>
      </form>
      <Link to="/login">Already Have An Account? Login</Link>
    </div>
  );
}

export default Register;
